(function () {
  /**
   * @ngdoc module
   * @name binky.core.api.report-broker
   * @description module that defines report broker resource services
   */
  angular.module('binky.core.api.report-broker', ['ngResource']);
})();
